import { observer } from 'mobx-react'
import React, { Component } from 'react'
import Card from '../../components/Card'
import Toggle from '../../components/Toggle'
import patient from '../../stores/patient'

@observer
export default class ScreeningReasonForm extends Component {
  render() {
    return (
      <Card>
        <Card.Title str="Reasons for Diagnosis" />
        <Card.Pad>
          <p style={{ color: "rgba(0,0,0,0.5)" }}><i className="fa fa-info-circle" />&nbsp;&nbsp;This information is used to tailor screening session content</p>
        </Card.Pad>
        <Card.Pad>
            <Toggle
                color="dark-blue"
                checked={patient.fields.screeningReasons.includes("LARGE_CUPS")}
                str="choices.screeningReason.forCounselor.LARGE_CUPS"
                onToggle={() => patient.toggleScreeningReason("LARGE_CUPS")}
            />
            <Toggle
                color="dark-blue"
                checked={patient.fields.screeningReasons.includes("DIFFERENT_SIZED_CUPS")}
                str="choices.screeningReason.forCounselor.DIFFERENT_SIZED_CUPS"
                onToggle={() => patient.toggleScreeningReason("DIFFERENT_SIZED_CUPS")}
            />
            <Toggle
                color="dark-blue"
                checked={patient.fields.screeningReasons.includes("DIVET")}
                str="choices.screeningReason.forCounselor.DIVET"
                onToggle={() => patient.toggleScreeningReason("DIVET")}
            />
            <Toggle
                color="dark-blue"
                checked={patient.fields.screeningReasons.includes("DAMAGE")}
                str="choices.screeningReason.forCounselor.DAMAGE"
                onToggle={() => patient.toggleScreeningReason("DAMAGE")}
            />
            <Toggle
                color="dark-blue"
                checked={patient.fields.screeningReasons.includes("BLOOD_SPOT")}
                str="choices.screeningReason.forCounselor.BLOOD_SPOT"
                onToggle={() => patient.toggleScreeningReason("BLOOD_SPOT")}
            />
            <Toggle
                color="dark-blue"
                checked={patient.fields.screeningReasons.includes("HIGH_PRESSURE")}
                str="choices.screeningReason.forCounselor.HIGH_PRESSURE"
                onToggle={() => patient.toggleScreeningReason("HIGH_PRESSURE")}
            />
        </Card.Pad>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/EditPatient/ScreeningReasonForm.js